import { useTranslation } from 'react-i18next';

/**
 * The way on out of a scene: the one press that finishes the place a student is standing in and
 * lets the run walk to the next.
 *
 * Shut until the run says the scene may be left. The rules are the server's and nothing on this
 * side works them out for itself, so a scene whose objectives are not met yet wears the button
 * greyed rather than hiding it — a student can see there is a way on, and what it is waiting for.
 *
 * It stands inside the place, beside what the student is carrying, rather than in the band across
 * the top. The band holds the way out of the *run*, and two buttons that end different things do
 * not belong side by side.
 */
export default function WayOn({ mayFinish, onFinish }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="player-way-on"
      onClick={onFinish}
      disabled={!mayFinish}
    >
      {t('player.wayOn')}
    </button>
  );
}
